import Cards from "../components/Cards"

import { useFirestoreContext } from "../context/FirestoreContext"
import { useAuthContext } from "../context/AuthContext"

import { useMemo } from "react"
export default function Images(){
  const { state } = useFirestoreContext()
  const { currentUser } = useAuthContext()
  const items = useMemo(() => {
    const filtered = state.items.filter(item => {
      const username = currentUser?.displayName.split(" ").join("")
      return item.user === username?.toLowerCase()
    })
    return currentUser ? filtered : []
  }, [state.items, currentUser])
  return(
    <div>
      <h1>My Comments</h1>
      <Cards items={items}/>
    </div>
  )
}